package com.htmlagent.site.i18n

// Generated from i18n/strings.json. Do not edit: edit the JSON and rebuild.

/** The texts of the landing area. */
interface LandingStrings {
    val openingSession: String

    val navHowItWorks: String

    val navInside: String

    val navAudience: String

    val navQuestions: String

    val navSamples: String

    val navStart: String

    val navMenu: String

    val navOpenMenu: String

    val navCloseMenu: String

    val skipToContent: String

    val heroEyebrow: String

    val heroLineOne: String

    val heroLineTwo: String

    val heroSubtitle: String

    val heroPrimary: String

    val heroSecondary: String

    val heroFacts: List<String>

    val heroFrameAddress: String

    val heroFrameLabel: String

    val stepsEyebrow: String

    val stepsTitle: String

    fun stepsOpen(name: String): String

    val stepsCta: String

    val stepOneKicker: String

    val stepOneTitle: String

    val stepOneShort: String

    val stepOneHint: String

    val stepOneBody: String

    val stepOneTags: List<String>

    val stepTwoKicker: String

    val stepTwoTitle: String

    val stepTwoShort: String

    val stepTwoHint: String

    val stepTwoBody: String

    val stepTwoTags: List<String>

    val stepThreeKicker: String

    val stepThreeTitle: String

    val stepThreeShort: String

    val stepThreeHint: String

    val stepThreeBody: String

    val stepThreeTags: List<String>

    val statsEyebrow: String

    val statsTitle: String

    val statPriceLabel: String

    val statPriceBody: String

    val statTemplatesLabel: String

    val statTemplatesBody: String

    val statChecksLabel: String

    val statChecksBody: String

    val statFileLabel: String

    val statFileBody: String

    val tipEyebrow: String

    val tipTitle: String

    val tipBody: String

    val tipCta: String

    val tipAmount: String

    val audienceEyebrow: String

    val audienceTitle: String

    val audienceLocalTitle: String

    val audienceLocalBody: String

    val audienceLocalLink: String

    val audiencePortfolioTitle: String

    val audiencePortfolioBody: String

    val audiencePortfolioLink: String

    val audienceEventTitle: String

    val audienceEventBody: String

    val audienceEventLink: String

    val audienceLaunchTitle: String

    val audienceLaunchBody: String

    val audienceLaunchLink: String

    val samplesEyebrow: String

    val samplesTitle: String

    val samplesNote: String

    fun samplesOpen(name: String): String

    fun samplesShotAlt(name: String): String

    val samplesAction: String

    val sampleBoysName: String

    val sampleBoysKind: String

    val sampleBoysLine: String

    val sampleLiriaName: String

    val sampleLiriaKind: String

    val sampleLiriaLine: String

    val sampleTormesName: String

    val sampleTormesKind: String

    val sampleTormesLine: String

    val sampleUmbraName: String

    val sampleUmbraKind: String

    val sampleUmbraLine: String

    val sampleNudoName: String

    val sampleNudoKind: String

    val sampleNudoLine: String

    val sampleFerroName: String

    val sampleFerroKind: String

    val sampleFerroLine: String

    val faqEyebrow: String

    val faqTitle: String

    val faqChangeQuestion: String

    val faqChangeAnswer: String

    val faqHostQuestion: String

    val faqHostAnswer: String

    val faqFreeQuestion: String

    val faqFreeAnswer: String

    val faqPhoneQuestion: String

    val faqPhoneAnswer: String

    val faqCloseQuestion: String

    val faqCloseAnswer: String

    val faqWixQuestion: String

    val faqWixAnswer: String

    val ctaLineOne: String

    val ctaLineTwo: String

    val ctaLead: String

    val ctaReturning: String

    val ctaNote: String

    val footerAbout: String

    val footerMadeWith: String

    fun footerCopyright(year: Int): String

    val navInstall: String

    val navContinue: String

    val installDismiss: String

    val enterTitle: String

    val enterLead: String

    val enterClose: String
}

/** The landing area in Spanish. */
internal object SpanishLandingStrings : LandingStrings {
    override val openingSession: String = "Abriendo sesión…"

    override val navHowItWorks: String = "Cómo funciona"

    override val navInside: String = "Qué te llevas"

    override val navAudience: String = "Para quién"

    override val navQuestions: String = "Preguntas"

    override val navSamples: String = "Ejemplos"

    override val navStart: String = "Empezar"

    override val navMenu: String = "Secciones de la página"

    override val navOpenMenu: String = "Abrir el menú"

    override val navCloseMenu: String = "Cerrar el menú"

    override val skipToContent: String = "Saltar al contenido"

    override val heroEyebrow: String = "CREAR TU PÁGINA WEB GRATIS CON IA"

    override val heroLineOne: String = "PIDE UNA WEB."

    override val heroLineTwo: String = "MÍRALA NACER."

    override val heroSubtitle: String = "Una página web para tu negocio, tu evento o tu trabajo, sin programar y sin plantillas. La ves escribirse delante de ti, línea a línea, y te la llevas en un fichero que es tuyo para siempre."

    override val heroPrimary: String = "Pedir mi página"

    override val heroSecondary: String = "Ver cómo funciona"

    override val heroFacts: List<String> = listOf(
        "En una frase",
        "Sin cuota mensual",
        "La ajustas hablando",
        "Te la descargas",
    )

    override val heroFrameAddress: String = "tu-pagina.html"

    override val heroFrameLabel: String = "Vista previa de una página generada"

    override val stepsEyebrow: String = "CÓMO FUNCIONA"

    override val stepsTitle: String = "TRES PASOS"

    override fun stepsOpen(name: String): String = "Ver el $name"

    override val stepsCta: String = "Probarlo"

    override val stepOneKicker: String = "Paso uno"

    override val stepOneTitle: String = "Lo cuentas. No hay nada que aprender."

    override val stepOneShort: String = "Lo cuentas en una frase"

    override val stepOneHint: String = "Una frase basta: ni menús, ni plantillas que elegir."

    override val stepOneBody: String = "Una frase: «una página para mi cafetería, con la carta y el horario». Ni menús, ni plantillas que elegir, ni cajas que arrastrar. Antes de escribir nada decide el tono, la letra y el color, y te dice en una línea qué ha elegido."

    override val stepOneTags: List<String> = listOf(
        "Una frase",
        "Sin plantillas",
        "Decide y lo dice",
    )

    override val stepTwoKicker: String = "Paso dos"

    override val stepTwoTitle: String = "La ves escribirse. No es una caja negra."

    override val stepTwoShort: String = "La ves escribirse por secciones"

    override val stepTwoHint: String = "Aparece delante de ti, y la ajustas hablando."

    override val stepTwoBody: String = "Va apareciendo sección a sección: primero la portada, luego el resto. No esperas a ciegas a que algo termine. Y lo que no te convenza se lo dices —«el botón en verde»— y solo cambia esa parte: lo demás se queda como estaba."

    override val stepTwoTags: List<String> = listOf(
        "En directo",
        "Sección a sección",
        "La ajustas hablando",
    )

    override val stepThreeKicker: String = "Paso tres"

    override val stepThreeTitle: String = "Te la llevas. No te queda ninguna atadura."

    override val stepThreeShort: String = "La descargas y es tuya"

    override val stepThreeHint: String = "Un fichero que se abre con doble clic, sin cuota."

    override val stepThreeBody: String = "La descargas y es tuya: un fichero que se abre con doble clic, también sin conexión. Sin cuota mensual y sin plataforma de por medio. Cada versión se guarda, así que puedes bajarte la de antes si prefieres aquella."

    override val stepThreeTags: List<String> = listOf(
        "Un fichero",
        "Sin cuota",
        "Tuya para siempre",
    )

    override val statsEyebrow: String = "QUÉ TE LLEVAS"

    override val statsTitle: String = "NADA DE POR MEDIO"

    override val statPriceLabel: String = "euros"

    override val statPriceBody: String = "Gratis. Sin cuota mensual, sin versión completa y sin tarjeta."

    override val statTemplatesLabel: String = "plantillas"

    override val statTemplatesBody: String = "Cada página se decide desde cero para lo tuyo. La cafetería y la asesoría no salen iguales."

    override val statChecksLabel: String = "comprobaciones"

    override val statChecksBody: String = "Antes de dártela se revisa el contraste, el tamaño de la letra y cómo se ve en el teléfono."

    override val statFileLabel: String = "fichero"

    override val statFileBody: String = "Se abre con doble clic. Funciona sin conexión y es tuyo para siempre."

    override val tipEyebrow: String = "SI TE HA SERVIDO"

    override val tipTitle: String = "Invítame a un café"

    override val tipBody: String = "HAL es gratis y va a seguir siéndolo: sin cuota, sin versión de pago y sin tarjeta. Si tu página te ha servido y te apetece, invítame a un café. Y si no, quédatela igual."

    override val tipCta: String = "Invítame a un café en Ko-fi"

    override val tipAmount: String = "Un café son 2 US$, o el importe que quieras."

    override val audienceEyebrow: String = "PARA QUIÉN ES"

    override val audienceTitle: String = "LO QUE PUEDES PEDIR"

    override val audienceLocalTitle: String = "Negocio de barrio"

    override val audienceLocalBody: String = "Una carta, un horario, un mapa y un teléfono: lo que la gente busca de verdad. Deja de perder al que te buscó en el teléfono y no encontró a qué hora abres."

    override val audienceLocalLink: String = "Pedir la mía"

    override val audiencePortfolioTitle: String = "Portfolio"

    override val audiencePortfolioBody: String = "Tu trabajo con el espacio que merece, y el contacto donde se encuentra. Un enlace que puedes pasar sin explicar nada antes."

    override val audiencePortfolioLink: String = "Empezar el mío"

    override val audienceEventTitle: String = "Evento"

    override val audienceEventBody: String = "Fecha, sitio, programa y una portada que se recuerde al día siguiente. Lista antes de que empieces a repartir el enlace."

    override val audienceEventLink: String = "Montar la página"

    override val audienceLaunchTitle: String = "Lanzamiento"

    override val audienceLaunchBody: String = "Qué es, para quién y por qué ahora. Con una llamada a la acción, no cinco. Sin esperar a que alguien te haga hueco en su agenda."

    override val audienceLaunchLink: String = "Escribirlo"

    override val samplesEyebrow: String = "LO QUE YA HA ESCRITO"

    override val samplesTitle: String = "NINGUNA SE PARECE"

    override val samplesNote: String = "Páginas escritas por el agente, no maquetas. Pulsa cualquiera para verla entera."

    override fun samplesOpen(name: String): String = "Abrir «$name» en una pestaña nueva"

    override fun samplesShotAlt(name: String): String = "Captura de la página web de $name, escrita por HAL"

    override val samplesAction: String = "Ver la página"

    override val sampleBoysName: String = "The Boys"

    override val sampleBoysKind: String = "Concierto"

    override val sampleBoysLine: String = "Un concierto en Madrid con fecha, sala y precio. Decidió naranja sobre negro y titulares en mayúsculas que ocupan el ancho entero."

    override val sampleLiriaName: String = "Casa Liria"

    override val sampleLiriaKind: String = "Hotel"

    override val sampleLiriaLine: String = "Un hotel pequeño en Menorca. Decidió crema, mucho aire y una galería escalonada, sin una sola foto de catálogo."

    override val sampleTormesName: String = "La Huerta del Tormes"

    override val sampleTormesKind: String = "Granja ecológica"

    override val sampleTormesLine: String = "Cestas de verdura por encargo. Decidió verdes de campo y poner primero lo que hay esta semana, no la historia de la huerta."

    override val sampleUmbraName: String = "Umbra"

    override val sampleUmbraKind: String = "Revista"

    override val sampleUmbraLine: String = "Una revista trimestral sobre ciudad y oficios. Decidió una retícula de imprenta y una tipografía condensada que ordena cinco reportajes sin ruido."

    override val sampleNudoName: String = "Nudo Norte"

    override val sampleNudoKind: String = "Ropa deportiva"

    override val sampleNudoLine: String = "Una marca de ropa técnica. Decidió abrir la portada con el desplazamiento y un catálogo de cinco prendas que se arrastran con el dedo."

    override val sampleFerroName: String = "Ferro Norte"

    override val sampleFerroKind: String = "Panel de inventario"

    override val sampleFerroLine: String = "Un control de almacén, no una página: busca, filtra y ajusta existencias, y los totales se recalculan solos."

    override val faqEyebrow: String = "ANTES DE PEDIRLA"

    override val faqTitle: String = "LO QUE SUELEN PREGUNTAR"

    override val faqChangeQuestion: String = "¿Y si quiero cambiar algo dentro de un año?"

    override val faqChangeAnswer: String = "Vuelves, se lo pides y cambia solo esa parte. O abres el fichero en cualquier editor de texto y lo tocas tú: está escrito para poder leerse."

    override val faqHostQuestion: String = "¿Dónde la pongo?"

    override val faqHostAnswer: String = "Donde quieras: es un fichero. Si ya tienes dominio, se lo pasas a quien te lo lleva y lo sube. Si no tienes nada, arrástralo a Netlify Drop y te da un enlace público en un minuto, gratis y sin cuenta. Lo que no hacemos es alojarla nosotros: te damos la página, no un sitio del que depender."

    override val faqFreeQuestion: String = "Si es gratis, ¿qué me vais a cobrar luego?"

    override val faqFreeAnswer: String = "Nada. No hay plan de pago, ni versión completa, ni prueba que caduque. Esto está empezando y lo que necesito ahora son páginas hechas, no cobros. Si te ha servido, abajo hay un botón para invitarme a un café."

    override val faqPhoneQuestion: String = "¿Se va a ver bien en el teléfono?"

    override val faqPhoneAnswer: String = "Sí, y no hay que fiarse de mi palabra: antes de entregártela se comprueban catorce cosas, entre ellas el contraste, el tamaño de la letra y cómo queda en una pantalla estrecha."

    override val faqCloseQuestion: String = "¿Y si esto cierra mañana?"

    override val faqCloseAnswer: String = "Tu página sigue funcionando. No llama a ningún servidor nuestro ni a ningún otro: se abre desde tu ordenador, aunque esta web ya no exista."

    override val faqWixQuestion: String = "¿Esto es como Wix?"

    override val faqWixAnswer: String = "No del todo. En un constructor la página vive dentro de su plataforma y pagas todos los meses por tenerla ahí. Aquí te llevas el fichero y se acabó la relación. A cambio, esto es una página, no una tienda ni un blog con veinte entradas: si necesitas eso, no soy la herramienta."

    override val ctaLineOne: String = "¿LISTO PARA"

    override val ctaLineTwo: String = "PEDIR LA TUYA?"

    override val ctaLead: String = "Una frase y la ves nacer. Gratis, sin cuenta y sin tarjeta."

    override val ctaReturning: String = "¿Ya has estado aquí? Escribe tu correo y te enviamos un enlace para recuperar tus páginas."

    override val ctaNote: String = "Sin registro y sin contraseña: te enviamos un enlace para entrar."

    override val footerAbout: String = "HAL escribe páginas completas en HTML, CSS y JavaScript, sin frameworks y sin paso de compilación. Le cuentas qué necesitas y te llevas el fichero."

    override val footerMadeWith: String = "Hecho con Kotlin, de punta a punta."

    override fun footerCopyright(year: Int): String = "© $year HAL"

    override val navInstall: String = "Instalar app"

    override val navContinue: String = "Continuar"

    override val installDismiss: String = "Ahora no"

    override val enterTitle: String = "Entra en HAL"

    override val enterLead: String = "Déjanos tu correo y te enviamos un enlace para entrar y guardar tus páginas. O empieza sin correo."

    override val enterClose: String = "Cerrar"
}

/** The landing area in English. */
internal object EnglishLandingStrings : LandingStrings {
    override val openingSession: String = "Opening session…"

    override val navHowItWorks: String = "How it works"

    override val navInside: String = "What you take home"

    override val navAudience: String = "Who it's for"

    override val navQuestions: String = "Questions"

    override val navSamples: String = "Examples"

    override val navStart: String = "Get started"

    override val navMenu: String = "Page sections"

    override val navOpenMenu: String = "Open the menu"

    override val navCloseMenu: String = "Close the menu"

    override val skipToContent: String = "Skip to content"

    override val heroEyebrow: String = "BUILD YOUR WEB PAGE FREE WITH AI"

    override val heroLineOne: String = "ASK FOR A SITE."

    override val heroLineTwo: String = "WATCH IT BUILD."

    override val heroSubtitle: String = "A web page for your business, your event or your work, with no coding and no templates. Watch it being written in front of you, line by line, and take it away in a file that is yours for good."

    override val heroPrimary: String = "Ask for my page"

    override val heroSecondary: String = "See how it works"

    override val heroFacts: List<String> = listOf(
        "In one sentence",
        "No monthly fee",
        "Adjust it by asking",
        "Yours to download",
    )

    override val heroFrameAddress: String = "your-page.html"

    override val heroFrameLabel: String = "Preview of a generated page"

    override val stepsEyebrow: String = "HOW IT WORKS"

    override val stepsTitle: String = "THREE STEPS"

    override fun stepsOpen(name: String): String = "Show $name"

    override val stepsCta: String = "Try it"

    override val stepOneKicker: String = "Step one"

    override val stepOneTitle: String = "You describe it. There is nothing to learn."

    override val stepOneShort: String = "You tell it in one sentence"

    override val stepOneHint: String = "One sentence is enough: no menus, no templates to choose from."

    override val stepOneBody: String = "One sentence: “a page for my café, with the menu and the opening hours”. No menus, no templates to choose from, no boxes to drag. Before writing anything it decides the tone, the type and the colour, and tells you in one line what it chose."

    override val stepOneTags: List<String> = listOf(
        "One sentence",
        "No templates",
        "Decides and says so",
    )

    override val stepTwoKicker: String = "Step two"

    override val stepTwoTitle: String = "You watch it being written. It is not a black box."

    override val stepTwoShort: String = "You watch it written section by section"

    override val stepTwoHint: String = "It appears in front of you, and you adjust it by asking."

    override val stepTwoBody: String = "It appears section by section: the cover first, then the rest. You are not waiting blind for something to finish. And whatever does not convince you, you say so — “make the button green” — and only that part changes: the rest stays as it was."

    override val stepTwoTags: List<String> = listOf(
        "Live",
        "Section by section",
        "Adjust it by asking",
    )

    override val stepThreeKicker: String = "Step three"

    override val stepThreeTitle: String = "You take it with you. Nothing ties you down."

    override val stepThreeShort: String = "You download it and it is yours"

    override val stepThreeHint: String = "A file that opens with a double click, and no fee."

    override val stepThreeBody: String = "You download it and it is yours: a file that opens with a double click, offline too. No monthly fee and no platform in between. Every version is kept, so you can take the earlier one if you prefer that one."

    override val stepThreeTags: List<String> = listOf(
        "One file",
        "No fee",
        "Yours for good",
    )

    override val statsEyebrow: String = "WHAT YOU TAKE HOME"

    override val statsTitle: String = "NOTHING IN THE WAY"

    override val statPriceLabel: String = "to pay"

    override val statPriceBody: String = "Free. No monthly fee, no full version and no card."

    override val statTemplatesLabel: String = "templates"

    override val statTemplatesBody: String = "Every page is decided from scratch for what you do. The café and the accountant do not come out alike."

    override val statChecksLabel: String = "checks"

    override val statChecksBody: String = "Before you get it, contrast, text size and how it looks on a phone are all checked."

    override val statFileLabel: String = "file"

    override val statFileBody: String = "Double-click and it opens. It works offline and it is yours for good."

    override val tipEyebrow: String = "IF IT HELPED"

    override val tipTitle: String = "Buy me a coffee"

    override val tipBody: String = "HAL is free and it is staying free: no fee, no paid tier, no card. If your page helped and you feel like it, buy me a coffee. And if not, keep it all the same."

    override val tipCta: String = "Buy me a coffee on Ko-fi"

    override val tipAmount: String = "A coffee is US$2, or whatever amount you like."

    override val audienceEyebrow: String = "WHO IT'S FOR"

    override val audienceTitle: String = "WHAT YOU CAN ASK FOR"

    override val audienceLocalTitle: String = "Local business"

    override val audienceLocalBody: String = "A menu, opening hours, a map and a phone number: what people actually look for. Stop losing whoever looked you up on their phone and never found out when you open."

    override val audienceLocalLink: String = "Ask for mine"

    override val audiencePortfolioTitle: String = "Portfolio"

    override val audiencePortfolioBody: String = "Your work with the room it deserves, and the contact where it can be found. A link you can pass on without explaining anything first."

    override val audiencePortfolioLink: String = "Start mine"

    override val audienceEventTitle: String = "Event"

    override val audienceEventBody: String = "Date, place, programme and a cover you still remember the next day. Ready before you start handing the link around."

    override val audienceEventLink: String = "Build the page"

    override val audienceLaunchTitle: String = "Product launch"

    override val audienceLaunchBody: String = "What it is, who it is for and why now. With one call to action, not five. Without waiting for somebody to fit you into their schedule."

    override val audienceLaunchLink: String = "Write it"

    override val samplesEyebrow: String = "WHAT IT HAS ALREADY WRITTEN"

    override val samplesTitle: String = "NO TWO ALIKE"

    override val samplesNote: String = "Pages generated while building the agent, not mock-ups."

    override fun samplesOpen(name: String): String = "Open “$name” in a new tab"

    override fun samplesShotAlt(name: String): String = "Screenshot of the $name web page, written by HAL"

    override val samplesAction: String = "See the page"

    override val sampleBoysName: String = "The Boys"

    override val sampleBoysKind: String = "Concert"

    override val sampleBoysLine: String = "A gig in Madrid with date, venue and price. It went for orange on black and capitals that take up the full width."

    override val sampleLiriaName: String = "Casa Liria"

    override val sampleLiriaKind: String = "Hotel"

    override val sampleLiriaLine: String = "A small hotel in Menorca. It went for cream, plenty of air and a stepped gallery, without a single stock-looking photo."

    override val sampleTormesName: String = "La Huerta del Tormes"

    override val sampleTormesKind: String = "Organic farm"

    override val sampleTormesLine: String = "Vegetable boxes to order. It went for field greens and put this week's produce first, not the farm's history."

    override val sampleUmbraName: String = "Umbra"

    override val sampleUmbraKind: String = "Magazine"

    override val sampleUmbraLine: String = "A quarterly magazine about the city and its trades. It went for a print grid and a condensed typeface that orders five features without noise."

    override val sampleNudoName: String = "Nudo Norte"

    override val sampleNudoKind: String = "Sportswear"

    override val sampleNudoLine: String = "A technical clothing label. It chose to open the cover with the scroll and a catalogue of five garments you drag with your finger."

    override val sampleFerroName: String = "Ferro Norte"

    override val sampleFerroKind: String = "Inventory dashboard"

    override val sampleFerroLine: String = "A stock control, not a page: it searches, filters and adjusts quantities, and the totals recalculate themselves."

    override val faqEyebrow: String = "BEFORE YOU ASK"

    override val faqTitle: String = "WHAT PEOPLE ASK"

    override val faqChangeQuestion: String = "What if I want to change something a year from now?"

    override val faqChangeAnswer: String = "You come back, you ask, and only that part changes. Or you open the file in any text editor and change it yourself: it is written to be read."

    override val faqHostQuestion: String = "Where do I put it?"

    override val faqHostAnswer: String = "Wherever you like: it is a file. If you already have a domain, hand it to whoever looks after it. If you have nothing, drag it onto Netlify Drop and you get a public link in a minute, free and without an account. What we do not do is host it: we give you the page, not a place to depend on."

    override val faqFreeQuestion: String = "If it is free, what will you charge me for later?"

    override val faqFreeAnswer: String = "Nothing. There is no paid plan, no full version and no trial that runs out. This is just starting, and what I need right now is pages made, not payments. If it helped, there is a button below to buy me a coffee."

    override val faqPhoneQuestion: String = "Will it look right on a phone?"

    override val faqPhoneAnswer: String = "Yes, and you do not have to take my word for it: before you get it, fourteen things are checked, contrast, text size and how it holds up on a narrow screen among them."

    override val faqCloseQuestion: String = "What if this shuts down tomorrow?"

    override val faqCloseAnswer: String = "Your page keeps working. It calls no server of ours and none of anybody else's: it opens from your own computer, even if this site no longer exists."

    override val faqWixQuestion: String = "Is this like Wix?"

    override val faqWixAnswer: String = "Not quite. In a site builder the page lives inside their platform and you pay every month to keep it there. Here you take the file and the relationship ends. In exchange, this is a page, not a shop or a blog with twenty posts: if that is what you need, I am not the tool."

    override val ctaLineOne: String = "READY TO ASK"

    override val ctaLineTwo: String = "FOR YOURS?"

    override val ctaLead: String = "One sentence and you watch it appear. Free, no account, no card."

    override val ctaReturning: String = "Been here before? Type your email and we will send you a link to get your pages back."

    override val ctaNote: String = "No sign-up and no password: we email you a link to sign in."

    override val footerAbout: String = "HAL writes complete pages in HTML, CSS and JavaScript, with no frameworks and no build step. You tell it what you need and you leave with the file."

    override val footerMadeWith: String = "Built with Kotlin, end to end."

    override fun footerCopyright(year: Int): String = "© $year HAL"

    override val navInstall: String = "Install app"

    override val navContinue: String = "Continue"

    override val installDismiss: String = "Not now"

    override val enterTitle: String = "Get into HAL"

    override val enterLead: String = "Leave your email and we will send you a link to sign in and keep your pages. Or start without one."

    override val enterClose: String = "Close"
}
